<script>
import { apiClient, storageService } from '@services'

import { notificationService } from '@services/'
import moment from 'moment'
import { SweetModal } from 'sweet-modal-vue'
import Loader from '@components/loader/loader'
import VueLoader from '@components/loader/VueLoader'
import { CAMPAIGN_ID, CAMPAIGN_ID_DUPLICATE } from '../constants/endponts'
import { mapMutations } from 'vuex'
export default {
  components: { SweetModal, Loader, VueLoader },
  props: {
    titleCenter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      totalNotifications: 2,
      currentRoute: null,
      projectsRoute: false,
      project: null,

      projectId: this.$route.params.projectId,
      campaignId: this.$route.params.campaignId,
      campaign: null,
      loaderRemove: false,
      lockStartCampaignButton: false,
    }
  },
  created() {
    this.loader = true
    this.getCampaign()
      .then((res) => {})
      .then(() => {
        this.loader = false
      })
  },
  methods: {
    ...mapMutations({
      updateForm: 'campaigns/UPDATE_CAMPAIGN_FORM',
      openModal: 'campaigns/OPEN_MODAL',
      closeModal: 'campaigns/CLOSE_MODAL',
      changeLoading: 'campaigns/LOADING',
    }),
    getUser() {
      return storageService.getItem('auth.currentUser').value
    },
    getCampaign() {
      return apiClient
        .get(CAMPAIGN_ID(this.campaignId))
        .then(
          (res) => {
            this.campaign = res.data
            this.project = res.data.app
          },
          (res) => {
            notificationService.handleResponse(res)
          }
        )
        .catch((err) => {
          console.log('error', err)
          notificationService.handleResponse(err)
          return err
        })
    },
    logoutFnc() {
      this.$router.push('/logout')
    },
    billing() {
      this.$router.push('/payment')
    },
    profile() {
      this.$router.push('/profile')
    },
    switchProject() {
      this.$router.push('/channels')
    },
    help() {
      this.$router.push('/help')
    },
    goToCampaigns() {
      this.$router.push('/projects/' + this.projectId + '/email-campaigns')
    },
    formatDate(date, withHour) {
      return moment(date).format(
        withHour ? 'MMM DD, YYYY - h:mm:ss A' : 'MMM DD, YYYY'
      )
    },
    openModalDelete(campaignName, campaignId) {
      this.$refs.modalDelete.open()
      this.selectedCampaign = {
        name: campaignName,
        id: campaignId,
      }
    },
    closeModalDelete() {
      this.$refs.modalDelete.close()
      this.selectedCampaign = ''
    },
    openModalRename(campaignName, campaignId) {
      this.$refs.modalRename.open()
      this.selectedCampaign = {
        name: campaignName,
        id: campaignId,
      }
    },
    closeModalRename() {
      this.$refs.modalRename.close()
      this.selectedCampaign = ''
    },
    duplicateCampaign() {
      this.loaderRemove = true
      apiClient.post(CAMPAIGN_ID_DUPLICATE(this.campaignId)).then(
        (res) => {
          this.loaderRemove = false
          notificationService.success('Campaign duplicated')
          this.changeLoading(true)
          this.$store.dispatch('campaigns/initComponent', this.projectId)
          this.goToCampaigns()
        },
        (res) => {
          this.loaderRemove = false
          notificationService.handleResponse(res.response)
          this.goToCampaigns()
        }
      )
    },
    pauseCampaign() {
      apiClient
        .patch(CAMPAIGN_ID(this.campaign.id), { status: 3 })
        .then((res) => {
          this.$store.dispatch('campaigns/initComponent', this.projectId)
          this.loaderRemove = false
          return res
        })
        .catch((err) => {
          this.loaderRemove = false
          return err
        })
    },
    reStartCampaign() {
      apiClient
        .patch(CAMPAIGN_ID(this.campaign.id), { status: 1 })
        .then((res) => {
          this.$store.dispatch('campaigns/initComponent', this.projectId)
          this.loaderRemove = false
          return res
        })
        .catch((err) => {
          this.loaderRemove = false
          return err
        })
    },
    deleteCampaign() {
      this.loaderRemove = true

      apiClient
        .delete(CAMPAIGN_ID(this.selectedCampaign.id))
        .then((res) => {
          this.$store.dispatch('campaigns/initComponent', this.projectId)
          this.closeModalDelete()
          this.loaderRemove = false
          this.goToCampaigns()
          return res
        })
        .catch((err) => {
          this.loaderRemove = false
          this.goToCampaigns()
          return err
        })
    },
    updateCampaignName(campaignName) {
      notificationService.success('Saving campaign Name')
      return apiClient
        .patch(CAMPAIGN_ID(this.campaign.id), { name: campaignName })
        .then(
          (res) => {
            this.campaign = res.data

            return res
          },
          (err) => {
            notificationService.handleResponse(err.response)
            return err
          }
        )
        .then((res) => {
          notificationService.success('Campaign Name Saved!')
          this.closeModalRename()
        })
    },
  },
  // computed: {
  //   ...authComputed,
  // },
}
</script>
<template>
  <span>
    <div class="container-fluid bg-white">
      <div
        class="d-flex align-items-center justify-content-between py-3 px-2 mb-1"
      >
        <div v-if="campaign && titleCenter" class="d-flex">
          <!-- ongoing -->
          <span v-if="campaign.status === 1">
            <button class="btn p-0" @click.prevent="pauseCampaign">
              <span>
                <img
                  src="@assets/images/icons/pause_circle.svg"
                  alt=""
                  height="64"
                />
              </span>
            </button>
          </span>

          <!-- paused -->
          <span
            v-if="
              campaign.status === 3 ||
                (campaign.status === 2 && !campaign.is_sent)
            "
          >
            <button
              class="btn p-0"
              :disabled="lockStartCampaignButton"
              @click.prevent="reStartCampaign"
            >
              <span>
                <img
                  src="@assets/images/icons/play_green.svg"
                  alt=""
                  height="64"
                />
              </span>
            </button>
          </span>
        </div>

        <div v-if="campaign">
          <div>
            <span class="d-flex">
              <h2 class="text-black h4 text-capitalize m-0">{{
                campaign.name
              }}</h2>

              <div class="dropdown">
                <button
                  id="dropdown-campaign-name-2"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="btn p-0"
                >
                  <span class="px-2">
                    <img
                      src="@assets/images/icons/three_dots.svg"
                      alt=""
                      height="17"
                    />
                  </span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right shadow-lg border-0"
                  aria-labelledby="dropdown-profile"
                >
                  <button
                    class="dropdown-item my-2 text-secondary"
                    @click.prevent="openModalRename(campaign.name, campaignId)"
                    >Edit Title</button
                  >
                  <!--
                  <button
                    class="dropdown-item my-2 text-secondary"
                    @click.prevent="profile"
                    >Refresh</button
                  >
                  -->
                  <button
                    class="dropdown-item my-2 text-secondary"
                    @click.prevent="duplicateCampaign"
                    >Duplicate</button
                  >
                  <!--
                  <button
                    class="dropdown-item my-2 text-secondary"
                    @click.prevent="help"
                    >Export</button
                  >
                  -->
                  <button
                    class="dropdown-item my-2 text-secondary"
                    @click.prevent="openModalDelete(campaign.name, campaignId)"
                    >Delete
                  </button>
                </div>
              </div>
            </span>
          </div>
          <!-- The name of the creator, the total of recipients and if there is or not something pause should be return by the API -->
          <small class="text-gray-light">
            {{ `Started ${formatDate(campaign.created)}` }}

            <br />

            {{ `${campaign.total_leads_count} recipients.` }}
          </small>
        </div>
        <div class="dropdown">
          <button
            id="dropdown-profile"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="btn border-0 bg-transparent p-0"
          >
            <small class="text-gray-text-light">
              <img
                src="@assets/images/icons/alpha-icon.svg"
                alt=""
                class="icon-user mr-2"
              />
              <img src="@assets/images/icons/chevron-down.png" alt="" />
            </small>
          </button>
          <div
            class="dropdown-menu dropdown-menu-right shadow-lg border-0"
            aria-labelledby="dropdown-profile"
          >
            <div class="dropdown-item-text padding-left-10">{{
              getUser().full_name
            }}</div>
            <div class="dropdown-item-text my-2 padding-left-10">{{
              getUser().plan_name
            }}</div>
            <button
              class="dropdown-item my-2 text-secondary"
              @click.prevent="switchProject"
              >Switch Project</button
            >
            <button
              class="dropdown-item my-2 text-secondary"
              @click.prevent="profile"
              >Profile</button
            >
            <button
              class="dropdown-item my-2 text-secondary"
              @click.prevent="billing"
              >Billing</button
            >
            <button
              class="dropdown-item my-2 text-secondary"
              @click.prevent="help"
              >Help</button
            >
            <button
              class="dropdown-item my-2 text-secondary"
              @click.prevent="logoutFnc"
              >Logout</button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Modal -->
    <SweetModal
      ref="modalDelete"
      overlay-theme="dark"
      width="50%"
      class="modal-campaign-delete"
      :blocking="loaderRemove"
      :pulse-on-block="!loaderRemove"
    >
      <div v-if="campaign" class="p-5 text-center position-relative">
        <div
          v-if="loaderRemove"
          class="position-absolute h-auto w-100 modal-loader"
        >
          <small class="change-page--spinner">
            <div class="spinner-container h-100">
              <Loader />
            </div>
          </small>
        </div>

        <h2 class="font-weight-bold px-4">{{ campaign.name }}</h2>
        <h5 class="font-weight-bold px-4 mb-4"
          >Do you really want to delete this campaign?</h5
        >

        <div class="d-flex align-items-center justify-content-center mt-5 mb-3">
          <button
            class="btn btn-outline text-gray-input mr-2"
            @click.prevent="closeModalDelete"
            >Cancel & Return</button
          >

          <button class="btn btn-danger px-5" @click.prevent="deleteCampaign">
            Delete
          </button>
        </div>
      </div>
    </SweetModal>

    <!-- Rename Modal -->
    <SweetModal
      ref="modalRename"
      overlay-theme="dark"
      width="50%"
      class="modal-campaign-delete"
      :blocking="loaderRemove"
      :pulse-on-block="!loaderRemove"
    >
      <div v-if="campaign" class="p-5 text-center position-relative">
        <div
          v-if="loaderRemove"
          class="position-absolute h-auto w-100 modal-loader"
        >
          <small class="change-page--spinner">
            <div class="spinner-container h-100">
              <Loader />
            </div>
          </small>
        </div>

        <h2 class="font-weight-bold px-4">Edit Campaign Title</h2>
        <div class="form-group">
          <!--<label for="projectName">
              <small>Campaign name</small>
            </label>-->
          <h5 class="font-weight-bold px-4 mb-4">
            Only you will see this name
          </h5>
          <BaseInputText
            v-model="campaign.name"
            name="campaignName"
            :placeholder="`Enter your title here`"
          />
        </div>

        <div class="d-flex align-items-center justify-content-center mt-5 mb-3">
          <button
            class="btn btn-outline text-gray-input mr-2"
            @click.prevent="closeModalRename"
            >Cancel & Return</button
          >

          <button
            class="btn btn-primary px-5"
            @click.prevent="updateCampaignName(campaign.name)"
          >
            Save
          </button>
        </div>
      </div>
    </SweetModal>
  </span>
</template>
